import Avatar from '@/components/ui/Avatar'
import Dropdown from '@/components/ui/Dropdown'
import withHeaderItem from '@/utils/hoc/withHeaderItem'
import { Link } from 'react-router-dom'
import { PiUserDuotone, PiSignOutDuotone } from 'react-icons/pi'
import { useAuth } from '@/auth'
import { useEffect, useState } from 'react'

type DropdownList = {
    label: string
    path: string
    icon: JSX.Element
}

const regCode = localStorage.getItem('RegCode');

const isRegCodeEmpty = !regCode || regCode.trim() === '';

// Assign path conditionally
const profilePath = isRegCodeEmpty
    ? '/profile/basicdetails?mc=2001'  // Fallback path
    : '/basicdetails';

const dropdownItemList: DropdownList[] = [
    {
        label: 'Profile',
        path: profilePath,
        icon: <PiUserDuotone />,
    },
];
const _UserDropdown = () => {
    const { signOut } = useAuth()

    const firstName = localStorage.getItem('firstName') || ''
    // Display the backend-masked email; fall back to the full username only if
    // the masked value isn't present.
    const email =
        localStorage.getItem('maskedUsername') ||
        localStorage.getItem('username') ||
        'No email available'

    const handleSignOut = () => {
        localStorage.removeItem('firstName')
        localStorage.removeItem('email')
        localStorage.removeItem('avatar')
        signOut()
    }

    const [avatar, setAvatar] = useState<string | null>(null)

    useEffect(() => {
        const fetchEmployeePhoto = async () => {
            const refNum = localStorage.getItem('employeePhotoRefNumber')
            if (!refNum) {
                console.warn('No refNum found in localStorage.')
                return
            }

            const url = `${import.meta.env.VITE_API_URL}/view/Viewing/${refNum}`
            const token = import.meta.env.VITE_API_URL_TOKEN

            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: 'image/*',
                    },
                })

                if (!response.ok) {
                    console.error(`Image fetch failed with status: ${response.status}`)
                    return
                }

                const blob = await response.blob()
                const objectURL = URL.createObjectURL(blob)
                setAvatar(objectURL)
            } catch (error) {
                console.error('Error fetching image:', error)
            }
        }

        fetchEmployeePhoto()

        return () => {
            if (avatar) {
                URL.revokeObjectURL(avatar)
            }
        }
    }, [])

    const avatarProps = avatar ? { src: avatar, alt: 'Employee Avatar' } : { children: <PiUserDuotone size={32} /> }

    return (
        <>
        <style>
            {`
            .top-bar-img img {
                object-fit: cover;
                object-position: top;
            }`}
            </style>
            <Dropdown
                className="flex"
                toggleClassName="flex items-center"
                renderTitle={
                    <div className="top-bar-img cursor-pointer flex items-center">
                        <Avatar size={32} {...avatarProps} />
                    </div>
                }
                placement="bottom-end"
            >
                <Dropdown.Item variant="header">
                    <div className="top-bar-img py-2 px-3 flex items-center gap-3">
                        <Avatar {...avatarProps} />
                        <div>
                            <div className="font-bold text-gray-900 dark:text-gray-100">
                                {firstName}
                            </div>
                            <div className="text-xs">{email}</div>
                        </div>
                    </div>
                </Dropdown.Item>

                <Dropdown.Item variant="divider" />

                {dropdownItemList.map((item) => (
                    <Dropdown.Item key={item.label} eventKey={item.label} className="px-0">
                        <Link className="flex h-full w-full px-2" to={item.path}>
                            <span className="flex gap-2 items-center w-full">
                                <span className="text-xl">{item.icon}</span>
                                <span>{item.label}</span>
                            </span>
                        </Link>
                    </Dropdown.Item>
                ))}

                <Dropdown.Item eventKey="Sign Out" className="gap-2" onClick={handleSignOut}>
                    <span className="text-xl">
                        <PiSignOutDuotone />
                    </span>
                    <span>Sign Out</span>
                </Dropdown.Item>
            </Dropdown>
        </>
    )
}

const UserDropdown = withHeaderItem(_UserDropdown)

export default UserDropdown
